export default "__VITE_ASSET__babe0703__"